import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BaseQueryErrorHandler } from "./@utils/BaseQueryErrorHandler";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: "/api/v2/ai-host/aliases",
  prepareHeaders: (headers) => {
    headers.set("Content-Type", "application/json");

    return headers;
  },
});

const baseQuery = BaseQueryErrorHandler(rawBaseQuery);

export const aliasesApi = createApi({
  reducerPath: "aliasesApi",
  baseQuery,
  endpoints: (builder) => ({
    getAliasesFromDocument: builder.query({
      query: ({ documentParams, version = null }) =>
        version
          ? `/list?${documentParams.toString()}&version=${version}`
          : `/list?${documentParams.toString()}`,
    }),
    getAliasesModels: builder.query({
      query: ({ listParams }) => `/models?${listParams.toString()}`,
    }),
    getAliasesPipeline: builder.query({
      query: ({ isArchived }) => `/pipeline?archived=${isArchived}`,
    }),
    postPipelineChanges: builder.mutation({
      query: (body) => ({
        url: "/pipeline",
        method: "POST",
        body,
      }),
    }),
    postNewAliasesCollection: builder.mutation({
      query: (newCollection) => ({
        url: "/copy",
        method: "POST",
        body: newCollection,
      }),
    }),
    putUpdateModel: builder.mutation({
      query: ({ id, labelsAliases, supportedFields }) => ({
        url: `?id=${id}`,
        method: "PUT",
        body: { labelsAliases, supportedFields },
      }),
    }),
    patchBulkAddSupportedFields: builder.mutation({
      query: ({ modelIds, supportedFields }) => ({
        url: "/bulk-supported-fields",
        method: "PATCH",
        body: { modelIds, supportedFields },
      }),
    }),
  }),
});

export const {
  useGetAliasesFromDocumentQuery,
  useGetAliasesModelsQuery,
  useGetAliasesPipelineQuery,
  usePostPipelineChangesMutation,
  usePostNewAliasesCollectionMutation,
  usePutUpdateModelMutation,
  usePatchBulkAddSupportedFieldsMutation,
} = aliasesApi;
